<ma-history-modal
  [task]="state.task"
  [taskInfos]="state.taskInfos"
  [assetPictureId]="state.machinePictureId"
  [details]="state.details"
  [asset]="taskModalService.machine$ | async"
>
</ma-history-modal>
